/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Dashboard,
    DashboardFromJSON,
    DashboardToJSON,
} from '../models/Dashboard';
import {
    type DashboardFleetStatusData,
    DashboardFleetStatusDataFromJSON,
    DashboardFleetStatusDataToJSON,
} from '../models/DashboardFleetStatusData';
import {
    type DashboardSafetyData,
    DashboardSafetyDataFromJSON,
    DashboardSafetyDataToJSON,
} from '../models/DashboardSafetyData';
import {
    type DashboardSafetyIncidentCounts,
    DashboardSafetyIncidentCountsFromJSON,
    DashboardSafetyIncidentCountsToJSON,
} from '../models/DashboardSafetyIncidentCounts';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';

export interface DashboardReadDashboardDataRequest {
    todayStart: Date;
    todayEnd: Date;
    shockEventChartPeriodStart: Date;
    shockEventChartPeriodEnd: Date;
    maintenanceChartPeriodStart: Date;
    maintenanceChartPeriodEnd: Date;
    topVehiclesByShockEventsPeriodStart: Date;
    topVehiclesByShockEventsPeriodEnd: Date;
    topUsersByShockEventsPeriodStart: Date;
    topUsersByShockEventsPeriodEnd: Date;
    vehicleUtilizationPeriodStart: Date;
    vehicleUtilizationPeriodEnd: Date;
}

export interface DashboardReadDashboardFleetStatusDataRequest {
    dateStart: Date;
    dateEnd: Date;
    datePreviousStart: Date;
    datePreviousEnd: Date;
}

export interface DashboardReadDashboardSafetyDataRequest {
    dateStart: Date;
    dateEnd: Date;
}

export interface DashboardReadDashboardSafetyIncidentCountsRequest {
    dateStart: Date;
    dateEnd: Date;
}

/**
 * DashboardApi - interface
 * 
 * @export
 * @interface DashboardApiInterface
 */
export interface DashboardApiInterface {
    /**
     * Creates request options for dashboardReadDashboardData without sending the request
     * @param {Date} todayStart 
     * @param {Date} todayEnd 
     * @param {Date} shockEventChartPeriodStart 
     * @param {Date} shockEventChartPeriodEnd 
     * @param {Date} maintenanceChartPeriodStart 
     * @param {Date} maintenanceChartPeriodEnd 
     * @param {Date} topVehiclesByShockEventsPeriodStart 
     * @param {Date} topVehiclesByShockEventsPeriodEnd 
     * @param {Date} topUsersByShockEventsPeriodStart 
     * @param {Date} topUsersByShockEventsPeriodEnd 
     * @param {Date} vehicleUtilizationPeriodStart 
     * @param {Date} vehicleUtilizationPeriodEnd 
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardDataRequestOpts(requestParameters: DashboardReadDashboardDataRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the whole data needed for the dashboard.
     * @summary Fetch the data for the dashboard
     * @param {Date} todayStart 
     * @param {Date} todayEnd 
     * @param {Date} shockEventChartPeriodStart 
     * @param {Date} shockEventChartPeriodEnd 
     * @param {Date} maintenanceChartPeriodStart 
     * @param {Date} maintenanceChartPeriodEnd 
     * @param {Date} topVehiclesByShockEventsPeriodStart 
     * @param {Date} topVehiclesByShockEventsPeriodEnd 
     * @param {Date} topUsersByShockEventsPeriodStart 
     * @param {Date} topUsersByShockEventsPeriodEnd 
     * @param {Date} vehicleUtilizationPeriodStart 
     * @param {Date} vehicleUtilizationPeriodEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardDataRaw(requestParameters: DashboardReadDashboardDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Dashboard>>;

    /**
     * Returns the whole data needed for the dashboard.
     * Fetch the data for the dashboard
     */
    dashboardReadDashboardData(requestParameters: DashboardReadDashboardDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Dashboard>;

    /**
     * Creates request options for dashboardReadDashboardFleetStatusData without sending the request
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @param {Date} datePreviousStart 
     * @param {Date} datePreviousEnd 
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardFleetStatusDataRequestOpts(requestParameters: DashboardReadDashboardFleetStatusDataRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the incident count breakdown by type
     * @summary Fetch incidents counts for dashboard safety section
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @param {Date} datePreviousStart 
     * @param {Date} datePreviousEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardFleetStatusDataRaw(requestParameters: DashboardReadDashboardFleetStatusDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardFleetStatusData>>;

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    dashboardReadDashboardFleetStatusData(requestParameters: DashboardReadDashboardFleetStatusDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardFleetStatusData>;

    /**
     * Creates request options for dashboardReadDashboardSafetyData without sending the request
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardSafetyDataRequestOpts(requestParameters: DashboardReadDashboardSafetyDataRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the most caused incidents for vehicles and users and chart points for incident timeline.
     * @summary Fetch the data for dashboard safety section
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardSafetyDataRaw(requestParameters: DashboardReadDashboardSafetyDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardSafetyData>>;

    /**
     * Returns the most caused incidents for vehicles and users and chart points for incident timeline.
     * Fetch the data for dashboard safety section
     */
    dashboardReadDashboardSafetyData(requestParameters: DashboardReadDashboardSafetyDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardSafetyData>;

    /**
     * Creates request options for dashboardReadDashboardSafetyIncidentCounts without sending the request
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardSafetyIncidentCountsRequestOpts(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the incident count breakdown by type
     * @summary Fetch incidents counts for dashboard safety section
     * @param {Date} dateStart 
     * @param {Date} dateEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardReadDashboardSafetyIncidentCountsRaw(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardSafetyIncidentCounts>>;

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    dashboardReadDashboardSafetyIncidentCounts(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardSafetyIncidentCounts>;

}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI implements DashboardApiInterface {

    /**
     * Creates request options for dashboardReadDashboardData without sending the request
     */
    async dashboardReadDashboardDataRequestOpts(requestParameters: DashboardReadDashboardDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['todayStart'] == null) {
            throw new runtime.RequiredError(
                'todayStart',
                'Required parameter "todayStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['todayEnd'] == null) {
            throw new runtime.RequiredError(
                'todayEnd',
                'Required parameter "todayEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['shockEventChartPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'shockEventChartPeriodStart',
                'Required parameter "shockEventChartPeriodStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['shockEventChartPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'shockEventChartPeriodEnd',
                'Required parameter "shockEventChartPeriodEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['maintenanceChartPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'maintenanceChartPeriodStart',
                'Required parameter "maintenanceChartPeriodStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['maintenanceChartPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'maintenanceChartPeriodEnd',
                'Required parameter "maintenanceChartPeriodEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['topVehiclesByShockEventsPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'topVehiclesByShockEventsPeriodStart',
                'Required parameter "topVehiclesByShockEventsPeriodStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['topVehiclesByShockEventsPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'topVehiclesByShockEventsPeriodEnd',
                'Required parameter "topVehiclesByShockEventsPeriodEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['topUsersByShockEventsPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'topUsersByShockEventsPeriodStart',
                'Required parameter "topUsersByShockEventsPeriodStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['topUsersByShockEventsPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'topUsersByShockEventsPeriodEnd',
                'Required parameter "topUsersByShockEventsPeriodEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['vehicleUtilizationPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'vehicleUtilizationPeriodStart',
                'Required parameter "vehicleUtilizationPeriodStart" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        if (requestParameters['vehicleUtilizationPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'vehicleUtilizationPeriodEnd',
                'Required parameter "vehicleUtilizationPeriodEnd" was null or undefined when calling dashboardReadDashboardData().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['todayStart'] != null) {
            queryParameters['today_start'] = (requestParameters['todayStart'] as any).toISOString();
        }

        if (requestParameters['todayEnd'] != null) {
            queryParameters['today_end'] = (requestParameters['todayEnd'] as any).toISOString();
        }

        if (requestParameters['shockEventChartPeriodStart'] != null) {
            queryParameters['shock_event_chart_period_start'] = (requestParameters['shockEventChartPeriodStart'] as any).toISOString();
        }

        if (requestParameters['shockEventChartPeriodEnd'] != null) {
            queryParameters['shock_event_chart_period_end'] = (requestParameters['shockEventChartPeriodEnd'] as any).toISOString();
        }

        if (requestParameters['maintenanceChartPeriodStart'] != null) {
            queryParameters['maintenance_chart_period_start'] = (requestParameters['maintenanceChartPeriodStart'] as any).toISOString();
        }

        if (requestParameters['maintenanceChartPeriodEnd'] != null) {
            queryParameters['maintenance_chart_period_end'] = (requestParameters['maintenanceChartPeriodEnd'] as any).toISOString();
        }

        if (requestParameters['topVehiclesByShockEventsPeriodStart'] != null) {
            queryParameters['top_vehicles_by_shock_events_period_start'] = (requestParameters['topVehiclesByShockEventsPeriodStart'] as any).toISOString();
        }

        if (requestParameters['topVehiclesByShockEventsPeriodEnd'] != null) {
            queryParameters['top_vehicles_by_shock_events_period_end'] = (requestParameters['topVehiclesByShockEventsPeriodEnd'] as any).toISOString();
        }

        if (requestParameters['topUsersByShockEventsPeriodStart'] != null) {
            queryParameters['top_users_by_shock_events_period_start'] = (requestParameters['topUsersByShockEventsPeriodStart'] as any).toISOString();
        }

        if (requestParameters['topUsersByShockEventsPeriodEnd'] != null) {
            queryParameters['top_users_by_shock_events_period_end'] = (requestParameters['topUsersByShockEventsPeriodEnd'] as any).toISOString();
        }

        if (requestParameters['vehicleUtilizationPeriodStart'] != null) {
            queryParameters['vehicle_utilization_period_start'] = (requestParameters['vehicleUtilizationPeriodStart'] as any).toISOString();
        }

        if (requestParameters['vehicleUtilizationPeriodEnd'] != null) {
            queryParameters['vehicle_utilization_period_end'] = (requestParameters['vehicleUtilizationPeriodEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dashboard/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the whole data needed for the dashboard.
     * Fetch the data for the dashboard
     */
    async dashboardReadDashboardDataRaw(requestParameters: DashboardReadDashboardDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Dashboard>> {
        const requestOptions = await this.dashboardReadDashboardDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardFromJSON(jsonValue));
    }

    /**
     * Returns the whole data needed for the dashboard.
     * Fetch the data for the dashboard
     */
    async dashboardReadDashboardData(requestParameters: DashboardReadDashboardDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Dashboard> {
        const response = await this.dashboardReadDashboardDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dashboardReadDashboardFleetStatusData without sending the request
     */
    async dashboardReadDashboardFleetStatusDataRequestOpts(requestParameters: DashboardReadDashboardFleetStatusDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['dateStart'] == null) {
            throw new runtime.RequiredError(
                'dateStart',
                'Required parameter "dateStart" was null or undefined when calling dashboardReadDashboardFleetStatusData().'
            );
        }

        if (requestParameters['dateEnd'] == null) {
            throw new runtime.RequiredError(
                'dateEnd',
                'Required parameter "dateEnd" was null or undefined when calling dashboardReadDashboardFleetStatusData().'
            );
        }

        if (requestParameters['datePreviousStart'] == null) {
            throw new runtime.RequiredError(
                'datePreviousStart',
                'Required parameter "datePreviousStart" was null or undefined when calling dashboardReadDashboardFleetStatusData().'
            );
        }

        if (requestParameters['datePreviousEnd'] == null) {
            throw new runtime.RequiredError(
                'datePreviousEnd',
                'Required parameter "datePreviousEnd" was null or undefined when calling dashboardReadDashboardFleetStatusData().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['datePreviousStart'] != null) {
            queryParameters['date_previous_start'] = (requestParameters['datePreviousStart'] as any).toISOString();
        }

        if (requestParameters['datePreviousEnd'] != null) {
            queryParameters['date_previous_end'] = (requestParameters['datePreviousEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dashboard/fleet-status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    async dashboardReadDashboardFleetStatusDataRaw(requestParameters: DashboardReadDashboardFleetStatusDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardFleetStatusData>> {
        const requestOptions = await this.dashboardReadDashboardFleetStatusDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardFleetStatusDataFromJSON(jsonValue));
    }

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    async dashboardReadDashboardFleetStatusData(requestParameters: DashboardReadDashboardFleetStatusDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardFleetStatusData> {
        const response = await this.dashboardReadDashboardFleetStatusDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dashboardReadDashboardSafetyData without sending the request
     */
    async dashboardReadDashboardSafetyDataRequestOpts(requestParameters: DashboardReadDashboardSafetyDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['dateStart'] == null) {
            throw new runtime.RequiredError(
                'dateStart',
                'Required parameter "dateStart" was null or undefined when calling dashboardReadDashboardSafetyData().'
            );
        }

        if (requestParameters['dateEnd'] == null) {
            throw new runtime.RequiredError(
                'dateEnd',
                'Required parameter "dateEnd" was null or undefined when calling dashboardReadDashboardSafetyData().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dashboard/safety`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the most caused incidents for vehicles and users and chart points for incident timeline.
     * Fetch the data for dashboard safety section
     */
    async dashboardReadDashboardSafetyDataRaw(requestParameters: DashboardReadDashboardSafetyDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardSafetyData>> {
        const requestOptions = await this.dashboardReadDashboardSafetyDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardSafetyDataFromJSON(jsonValue));
    }

    /**
     * Returns the most caused incidents for vehicles and users and chart points for incident timeline.
     * Fetch the data for dashboard safety section
     */
    async dashboardReadDashboardSafetyData(requestParameters: DashboardReadDashboardSafetyDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardSafetyData> {
        const response = await this.dashboardReadDashboardSafetyDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dashboardReadDashboardSafetyIncidentCounts without sending the request
     */
    async dashboardReadDashboardSafetyIncidentCountsRequestOpts(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['dateStart'] == null) {
            throw new runtime.RequiredError(
                'dateStart',
                'Required parameter "dateStart" was null or undefined when calling dashboardReadDashboardSafetyIncidentCounts().'
            );
        }

        if (requestParameters['dateEnd'] == null) {
            throw new runtime.RequiredError(
                'dateEnd',
                'Required parameter "dateEnd" was null or undefined when calling dashboardReadDashboardSafetyIncidentCounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dashboard/safety/incident-counts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    async dashboardReadDashboardSafetyIncidentCountsRaw(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardSafetyIncidentCounts>> {
        const requestOptions = await this.dashboardReadDashboardSafetyIncidentCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardSafetyIncidentCountsFromJSON(jsonValue));
    }

    /**
     * Returns the incident count breakdown by type
     * Fetch incidents counts for dashboard safety section
     */
    async dashboardReadDashboardSafetyIncidentCounts(requestParameters: DashboardReadDashboardSafetyIncidentCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardSafetyIncidentCounts> {
        const response = await this.dashboardReadDashboardSafetyIncidentCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
